import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Button, Spin, Typography } from 'antd';
import {
    InfoCircleOutlined, PictureOutlined, AppstoreOutlined,
    HomeOutlined, CustomerServiceOutlined, DatabaseOutlined,
    ShoppingCartOutlined, CommentOutlined, TeamOutlined,
    ArrowLeftOutlined,
    MoneyCollectOutlined,
} from '@ant-design/icons';
import { useSingleService } from './SingleServiceStore';
import ServiceInfo from './ServiceInfo';
import ServiceImages from './ServiceImages';
import SpecificData from './SpecificData';
import Halls from './Halls';
import Songs from './Songs';
import Warehouse from './Warehouse';
import ServiceOrders from './ServiceOrders';
import ServiceComments from './ServiceComments';
import ServiceEmployees from './ServiceEmployees';
import ServiceTarrifs from './ServiceTarrifs';

const { Text } = Typography;

function SingleServiceMain() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { service, loading, loadService, reset } = useSingleService();
    useEffect(() => {
        if (id) loadService(id);
        return () => reset();
    }, [id, loadService, reset]);

    if (loading && !service) {
        return <Spin size="large" style={{ display: 'block', margin: '80px auto' }} />;
    }

    const tabLabel = (icon, label) => (
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {icon} {label}
        </span>
    );


    const commonTabs = [
        { key: 'info', label: tabLabel(<InfoCircleOutlined />, "Ma'lumotlar"), children: <ServiceInfo /> },
        { key: 'images', label: tabLabel(<PictureOutlined />, 'Rasmlar'), children: <ServiceImages serviceId={id} /> },
        { key: 'specific', label: tabLabel(<AppstoreOutlined />, "Maxsus ma'lumotlar"), children: <SpecificData stype={service?.vendor_types_id} serviceId={id} /> },
    ];

    const commonEndTabs = [
        { key: 'warehouse', label: tabLabel(<DatabaseOutlined />, 'Ombor'), children: <Warehouse serviceId={id} /> },
        { key: 'comments', label: tabLabel(<CommentOutlined />, 'Izohlar'), children: <ServiceComments serviceId={id} /> },
    ];

    const restoranTabs = [
        ...commonTabs,
        { key: 'halls', label: tabLabel(<HomeOutlined />, 'Zallar'), children: <Halls serviceId={id} /> },
        ...commonEndTabs,
        { key: 'tariffs', label: tabLabel(<MoneyCollectOutlined />, 'Tariflar'), children: <ServiceTarrifs serviceId={id} /> }
    ];
    const tariffsTab = { key: 'tariffs', label: tabLabel(<MoneyCollectOutlined />, 'Tariflar'), children: <ServiceTarrifs serviceId={id} simple /> };

    const singerTabs = [
        ...commonTabs,
        { key: 'songs', label: tabLabel(<CustomerServiceOutlined />, "Qo'shiqlar"), children: <Songs serviceId={id} /> },
        ...commonEndTabs,
        tariffsTab,
    ];
    const otherTabs = [
        ...commonTabs,
        ...commonEndTabs,
        tariffsTab,
    ];



    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate(-1)}
                    style={{ borderRadius: 10 }}
                >
                    Orqaga
                </Button>
                <Text strong style={{ fontSize: 20 }}>
                    {service?.name || 'Xizmat'}
                </Text>
            </div>

            <Tabs
                defaultActiveKey="info"
                type="card"
                items={service?.vendor_types_id === 1 
                    ? restoranTabs 
                    : (service?.vendor_types_id === 3) 
                        ? singerTabs 
                        : otherTabs}
            />
        </div>
    );
}

export default SingleServiceMain;